import '@uhg-oicp/atlas-chatbot-v2/dist/static/main.js';
import styled from 'styled-components';

const ChatbotContainer = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 9999;
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }
`;

console.log('LINK_ENVV:', process.env.LINK_ENV);

export function Dashboard({ site, bearerToken }): JSX.Element {
  return (
    <ChatbotContainer data-test-id="dashboard-container">
      <chatbot-component
        customerTeamName="Horizon"
        product="Horizon"
        aideId={site.aideId}
        ingestionType="sparse"
        theme="dark"
        initiallyOpen="false"
        chatbotType="floating"
        env={process.env.LINK_ENV || 'stage'}
        suggestion="false"
        bearerToken={bearerToken}
      ></chatbot-component>
    </ChatbotContainer>
  );
}

export default Dashboard;
